// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-icons[data-v-a8a387fa]{margin:0}.custom-footer-class[data-v-a8a387fa]{margin-top:10px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
